import { Form, Input } from "antd";
import React from "react";

const ClientServerUrl: React.FC = () => {
  return (
    <Form.Item name="organizationServerUrl" label="Client Server Url">
      <Input />
    </Form.Item>
  );
};

export default ClientServerUrl;
